import { Toast } from '@leverege/ui-elements'
import { fixDependencies } from 'mathjs'
import NotifyActions from './NotifyActions'

const LOADING_GEOTILES = 'LOADING_GEOTILES'
const GET_GEOTILES = 'GET_GEOTILES'
const GEOTILE_ERRORS = 'GEOTILE_ERRORS'

const GET_GEOTILE = 'GET_GEOTILE'
const GEOTILE_ERROR = 'GEOTILE_ERROR'
const LOADING_GEOTILE = 'LOADING_GEOTILE'

const ADD_GEOTILE = 'ADD_GEOTILE'
const REMOVE_GEOTILE = 'REMOVE_GEOTILE'
const UPDATE_GEOTILE = 'UPDATE_GEOTILE'

const UPDATE_EDITOR = 'UPDATE_EDITOR'

const endpoints = {
  create : projectId => `v1/project/${projectId}/geotile`,
  retrieve : ( projectId, geotileId ) => `v1/project/${projectId}/geotile/${geotileId}`,
  list : projectId => `v1/project/${projectId}/geotile`,
  update : ( projectId, geotileId ) => `v1/project/${projectId}/geotile/${geotileId}`,
  upload : ( projectId, geotileId ) => `v1/project/${projectId}/geotile/${geotileId}/upload`,
  generate : ( projectId, geotileId ) => `v1/project/${projectId}/geotile/${geotileId}/generate`,
  delete : ( projectId, geotileId ) => `v1/project/${projectId}/geotile/${geotileId}`
}

const _getGeotile = geotile => ( { type : GET_GEOTILE, geotile } )
const _updateGeotile = geotile => ( { type : UPDATE_GEOTILE, geotile } )
const _getGeotiles = geotiles => ( { type : GET_GEOTILES, geotiles } )
const _createGeotile = geotile => ( { type : ADD_GEOTILE, geotile } )
const _deleteGeotile = geotileId => ( { type : REMOVE_GEOTILE, geotileId } )

const updateEditor = nEditorState => ( { type : UPDATE_EDITOR, editor : nEditorState } )

function list( { projectId } ) {
  return async function( dispatch, getState, api ) {
    dispatch( { type : LOADING_GEOTILES } )
    try {
      const geotiles = await api
        .child( endpoints.list( projectId ) )
        .get()

      dispatch( _getGeotiles( geotiles ) )
    } catch ( ex ) {
      Toast.error( [ 'Error fetching Geotile list', ex.message ] )
    }
  }
}

function create( { projectId, history } ) {
  return async function( dispatch, getState, api ) {

    try {
      const body = new FormData()
      body.append( 'projectId', projectId )
      body.append( 'name', 'My Geotile' )
      const res = await fetch(
        `${api.options.host}/${endpoints.create( projectId )}`, {
          method : 'POST',
          body,
          headers : {
            Authorization : api.options.auth.getToken()
          }
        } )
      const geotile = await res.json()

      const { id : geotileId } = geotile
      Toast.success( [ 'Created new geotile', geotileId ] )
      dispatch( _createGeotile( geotile ) )
      history.push( `geotile/${geotileId}` )
    } catch ( ex ) {
      Toast.error( [ 'Error creating geotile', ex.message ] )
    }
  }
}

function update( { projectId, geotileId, body } ) {
  return async function( dispatch, getState, api ) {
    let generate = false
    if ( body.get( 'coordinates' ) ) {
      generate = true
    }

    try {
      const res = await fetch(
        `${api.options.host}/${endpoints.update( projectId, geotileId )}?generate=${generate}`, {
          method : 'PATCH',
          body,
          headers : {
            Authorization : api.options.auth.getToken()
          }
        } )

      const jsonRes = await res.json()
      if ( jsonRes.message ) {
        throw jsonRes
      }
      dispatch( _updateGeotile( jsonRes ) )
    } catch ( ex ) {
      Toast.error( [ 'Error updating tile', ex.message ] )
    }
  }
}

function getGeotile( { projectId, geotileId } ) {
  return async function( dispatch, getState, api ) {
    try {
      const geotile = await api
        .child( endpoints.retrieve( projectId, geotileId ) )
        .get()

      dispatch( _getGeotile( geotile ) )
    } catch ( ex ) {
      console.error( 'error getting geotile', geotileId, ':', ex )
    }
  }
}

function deleteGeotile( { geotileId, projectId } ) {
  return async function( dispatch, getState, api ) {
    try {
      const jsonRes = await api
        .child( `${endpoints.delete( projectId, geotileId )}?force=true` )
        .delete()

      if ( jsonRes.message ) {
        throw jsonRes
      }
      dispatch( _deleteGeotile( geotileId ) )
      Toast.success( `Deleted geotile ${geotileId}` )
    } catch ( ex ) {
      console.error( ex, ex.message )
      Toast.error( [ `Error deleting tile ${geotileId}`, ex.message ] )
    }
  }
}

module.exports = {
  ADD_GEOTILE,
  GET_GEOTILE,
  GET_GEOTILES,
  UPDATE_GEOTILE,
  REMOVE_GEOTILE,
  LOADING_GEOTILES,
  LOADING_GEOTILE,
  UPDATE_GEOTILE,
  UPDATE_EDITOR,

  create,
  update,
  getGeotile,
  deleteGeotile,
  list,
  updateEditor
}
